import React from "react";
import "./newUserMobile.css";

// Import images from the assets folder
import redirectImage from "../../assets/Redirect_Image.webp";
import Seo from "../../seo/Seo";

const NewUserMobile = () => {
  return (
    <div className="thank-you-container">
      <Seo path="/new-user-mobile.html" />

      <h1>Thank you for joining!</h1>

      <div className="subheader">
        <p>Your account has been <br />successfully created!</p>
      </div>

      {/* Redirect image */}
      <img width={600} height={407} decoding="async" id="redirect-image" src={redirectImage} alt="A raindrop marking a finished sign-up" />

      <p>
        Currently, we only support desktop and laptop use, so please log in on
        your computer for the full experience. Stay tuned though, a mobile app is <br /> coming soon!
      </p>
      <p>
        For any questions please reach out to{" "}
        <a href="mailto:adminrain@raincareers.com">adminrain@raincareers.com</a>
      </p>

      <div className="button-container">
        <a
          href="https://www.raincareers.com/"
          target="_blank"
          rel="noreferrer"
        >
          Back to RAIN
        </a>
      </div>
    </div>
  );
};

export default NewUserMobile;
